import React, { useState } from 'react';

import { SearchableDropdown } from '@scholastic/volume-react';

import './CounterReportsDropdown.scss';

export type TypeOfCounterReport = '' | 'csections' | 'csrchsess';

export interface CounterReportDropdownPops {
  onSelect: (value: TypeOfCounterReport) => void;
}

export interface CounterReportDropdownValue {
  label: string;
  value: TypeOfCounterReport;
}

const CounterReportDropdown = ({ onSelect }: CounterReportDropdownPops) => {
  // eslint-disable-next-line
  const [allReportTypes, setAllReportTypes] = useState<CounterReportDropdownValue[]>([
    {
      label: 'Book Report 2 (R1) – Section Requests by Month and Title',
      value: 'csections',
    },
    {
      label: 'Book Report 5 (R1) – Searches by Month and Title',
      value: 'csrchsess',
    },
  ]);

  return (
    <div id="counterReportType">
      <SearchableDropdown
        className="stats-counter-reports-dropdown"
        items={allReportTypes}
        onItemSelect={(selectedItem: CounterReportDropdownValue | any) => {
          onSelect(selectedItem.value);
        }}
      />
    </div>
  );
};

export default CounterReportDropdown;
